import Component from '@glimmer/component';
import { crawlingSessionEndReasonExplanations } from 'nightwatch-web/constants/site-audit';

export default class CrawlingSessionEndReasonComponent extends Component {
  get endReason() {
    return crawlingSessionEndReasonExplanations[this.args.reason];
  }
}
